export const ruleRunner = (field: any, name: any, ...validations: any[]) => {
  return (state: any) => {
    for (const v of validations) {
      const errorMessageFunc = v(state[field], state);

      if (errorMessageFunc) {
        return { [field]: errorMessageFunc(name) };
      }
    }

    return null;
  };
};

export const run = (state: any, runners: any) => {
  return runners.reduce((memo: any, runner: any) => {
    return Object.assign(memo, runner(state));
  }, {});
};
